export default __webpack_public_path__ + "static/media/delete.5cca3a6f.svg";